export default class TableRegionChangeEvent{
    constructor(oldValue, newValue){
        this.oldValue = oldValue;
        this.newValue = newValue;
    }
}


// WEBPACK FOOTER //
// ./web/js/table/TableRegionChangeEvent.js